import React from 'react';

// Ilustración del héroe: la empresa en el centro y las cuatro cosas que tienen
// que funcionar para que trabaje (Hacienda, la sucursal, los respaldos y el
// correo), unidas por líneas que se dibujan una vez al cargar.
//
// Es un dibujo, no un tablero: no muestra estados ni cifras para no sugerir un
// producto de monitoreo que no existe. SVG en línea (unos 3 KB) en vez de una
// imagen: nítido en cualquier pantalla y sin otra descarga antes del LCP.
const nodos = [
  { x: 78, y: 70, t1: 'Hacienda', t2: 'factura 4.4', d: 'M6 2.5h9l4 4V21l-2.5-1.5L14 21l-2-1.5L10 21l-2.5-1.5L5 21V3.5a1 1 0 0 1 1-1ZM9 9h6M9 12.5h6M9 16h3.5' },
  { x: 322, y: 70, t1: 'Respaldos', t2: 'fuera del sitio', d: 'M7 18.5h10.5a4 4 0 0 0 .6-7.95A6 6 0 0 0 6.6 9.1 4.75 4.75 0 0 0 7 18.5Z' },
  { x: 78, y: 290, t1: 'Sucursal', t2: 'por VPN', d: 'M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16M15 10h4a1 1 0 0 1 1 1v10M3 21h18M8 8h3M8 12h3M8 16h3' },
  { x: 322, y: 290, t1: 'Correo', t2: 'Microsoft 365', d: 'M3 5h18v14H3zM3.5 6.5l8.5 6.5 8.5-6.5' },
];

const CX = 200;
const CY = 180;

function MapaTI() {
  return (
    <svg
      className="mapa"
      viewBox="0 0 400 372"
      role="img"
      aria-labelledby="mapa-titulo"
      width="400"
      height="372"
    >
      <title id="mapa-titulo">
        Su empresa conectada con Hacienda, sus respaldos, su sucursal y su correo: lo que mantenemos funcionando.
      </title>
      {/* Retícula de puntos: el plano sobre el que se dibuja la red. */}
      <defs>
        <pattern id="mapa-puntos" width="20" height="20" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.2" className="mapa__punto" />
        </pattern>
      </defs>
      <rect x="0" y="0" width="400" height="372" rx="16" className="mapa__fondo" />
      <rect x="0" y="0" width="400" height="372" rx="16" fill="url(#mapa-puntos)" />

      {nodos.map((n, i) => (
        <g key={n.t1}>
          {/* Línea en codo, como un cable: sale horizontal del centro y sube/baja. */}
          <path
            className="mapa__linea"
            style={{ animationDelay: `${120 + i * 110}ms` }}
            d={`M${CX} ${CY} H${(CX + n.x) / 2} V${n.y} H${n.x}`}
            pathLength="1"
          />
          <circle
            className="mapa__pulso"
            style={{ animationDelay: `${520 + i * 110}ms` }}
            cx={(CX + n.x) / 2}
            cy={n.y}
            r="5"
          />
        </g>
      ))}

      {nodos.map((n) => (
        <g key={`${n.t1}-nodo`} transform={`translate(${n.x} ${n.y})`}>
          <rect x="-30" y="-30" width="60" height="60" rx="12" className="mapa__nodo" />
          <g transform="translate(-14 -14) scale(1.1667)">
            <path d={n.d} className="mapa__icono" />
          </g>
          <text y="54" className="mapa__t1" textAnchor="middle">
            {n.t1}
          </text>
          <text y="74" className="mapa__t2" textAnchor="middle">
            {n.t2}
          </text>
        </g>
      ))}

      <g transform={`translate(${CX} ${CY})`}>
        <rect x="-62" y="-40" width="124" height="80" rx="14" className="mapa__centro" />
        <text y="-4" className="mapa__centro-t1" textAnchor="middle">
          Su empresa
        </text>
        <text y="20" className="mapa__centro-t2" textAnchor="middle">
          funcionando
        </text>
      </g>
    </svg>
  );
}

export default MapaTI;
